import { FC } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';

import Text from 'components/_core/Text';
import RebrandedPrice from 'components/Price/rebranded';

import { ListItem } from './components/ListItem';
import locales from './locales';

interface PresentationColumnProps {
  imgSrc: string;
  title: string;
  price: number;
  items: string[];
  description?: string;
}

export const PresentationColumn: FC<PresentationColumnProps> = ({
  description,
  imgSrc,
  items,
  price,
  title,
}) => (
  <Flex
    _last={{
      border: 'none',
    }}
    borderBottom={{
      base: '1px solid',
      lg: 'none',
    }}
    borderBottomColor={{
      base: 'grey.300',
      lg: 'none',
    }}
    borderRight={{
      base: 'none',
      lg: '1px solid',
    }}
    borderRightColor={{
      base: 'none',
      lg: 'grey.300',
    }}
    flex={1}
    flexDirection="column"
  >
    <Flex
      background="grey.100"
      height="114px"
      justifyContent="center"
      overflow="hidden"
    >
      <Image height="160px" marginTop="-space-8" src={imgSrc} />
    </Flex>
    <Box padding="space-24">
      <Text
        fontSize="font-18"
        fontWeight="weight-500"
        marginBottom="space-4"
        textAlign="left"
        variant="primary"
      >
        {title}
      </Text>
      <Flex>
        <RebrandedPrice size="sm" value={price} withoutCents />
        <Text fontSize="font-13" marginLeft="space-6">
          {locales.excludingVAT}
        </Text>
      </Flex>
    </Box>
    <Box
      flex={{
        base: 'none',
        lg: 1,
      }}
    >
      <Flex
        borderTop="1px solid"
        borderTopColor="grey.300"
        flex={1}
        flexDirection="column"
        height={{
          base: 'auto',
          lg: '100%',
        }}
        padding="space-24"
      >
        {items.map((item) => (
          <ListItem key={item}>{item}</ListItem>
        ))}
        {description ? (
          <Text
            alignSelf={{
              base: 'flex-start',
              lg: 'flex-end',
            }}
            fontSize="font-13"
            marginTop={{
              base: 'space-16',
              lg: 'auto',
            }}
            variant="secondary"
          >
            {description}
          </Text>
        ) : null}
      </Flex>
    </Box>
  </Flex>
);
